import * as actionTypes from '../../actions/actionTypes';

const initialState = {
  byPropertyId: {}
};

const reducer = (state = initialState, action) => {
  let nextByPropertyId;
  switch (action.type) {
    case actionTypes.SET_PROPERTY:
      const dars = state.byPropertyId[action.property.propertyId];
      if (dars) {
        return state;
      } else {
        return {
          ...state,
          byPropertyId: {
            ...state.byPropertyId,
            [action.property.propertyId]: {
              byId: {}
            }
          }
        };
      }
    case actionTypes.SET_PROPERTIES:
      nextByPropertyId = { ...state.byPropertyId };
      for (const property of action.properties) {
        if (!property.isDeleted) {
          if (!nextByPropertyId[property.propertyId]) {
            nextByPropertyId[property.propertyId] = {
              byId: {}
            };
          }
        } else {
          delete nextByPropertyId[property.propertyId];
        }
      }
      return {
        ...state,
        byPropertyId: nextByPropertyId
      };
    case actionTypes.dars.SET_DAR:
      nextByPropertyId = { ...state.byPropertyId };
      if (nextByPropertyId[action.dar.propertyId]) {
        nextByPropertyId[action.dar.propertyId] = {
          ...nextByPropertyId[action.dar.propertyId],
          byId: {
            ...nextByPropertyId[action.dar.propertyId].byId,
            [action.dar.patrolId]: action.dar
          }
        };
      } else {
        nextByPropertyId[action.dar.propertyId] = {
          byId: {
            [action.dar.patrolId]: action.dar
          }
        };
      }
      return {
        ...state,
        byPropertyId: nextByPropertyId
      };
    case actionTypes.dars.SET_DARS:
      nextByPropertyId = { ...state.byPropertyId };
      for (const dar of action.dars) {
        if (nextByPropertyId[dar.propertyId]) {
          nextByPropertyId[dar.propertyId] = {
            ...nextByPropertyId[dar.propertyId],
            byId: {
              ...nextByPropertyId[dar.propertyId].byId,
              [dar.patrolId]: dar
            }
          };
        } else {
          nextByPropertyId[dar.propertyId] = {
            byId: {
              [dar.patrolId]: dar
            }
          };
        }
      }
      return {
        ...state,
        byPropertyId: nextByPropertyId
      };
    default:
      return state;
  }
};

export default reducer;